import type {
  FormVariables,
  FormData,
} from './../../ContactForm/ContactFormJSON.types';

const isProductionSite =
  window.location.origin === 'https://www.fijiwaterfoundation.org';

const contactFormVariables: FormVariables = {
  endpoint: isProductionSite
    ? 'https://cf.wonderful.com'
    : 'https://dev-cf.wonderful.com', // Link for dev form endpoint: https://dev-cf.wonderful.com
  routingStatus: isProductionSite ? 'True' : 'false', // True for prod (with capital 'T'). false for dev
  errorMessage: 'Please correct the fields in red.',
  noticeMessage: '* Denotes a required field',
};

const hiddenFields: FormData = {
  visibleFieldsetDependencies: [['form_id', 'default']],
  legend: '',
  fields: [
    {
      type: 'hidden',
      label: 'Form ID',
      name: 'form_id',
      validationMessage: 'Please enter form id',
      required: true,
      defaultValue: 'fiji_foundation_contact_us',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
  ],
};

const formFields: FormData = {
  visibleFieldsetDependencies: [['first_name', 'default']],
  legend: '',
  fields: [
    {
      type: 'text',
      label: 'First Name*',
      name: 'first_name',
      validationMessage: 'Please enter first name',
      required: true,
      defaultValue: '',
      autocomplete: 'given-name',
      placeholder: 'First Name*',
      maxLength: 256,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
    {
      type: 'text',
      label: 'Last Name*',
      name: 'last_name',
      validationMessage: 'Please enter surname',
      required: true,
      defaultValue: '',
      autocomplete: 'family-name',
      placeholder: 'Last Name*',
      maxLength: 256,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
    {
      type: 'email',
      label: 'Email Address*',
      name: 'user_email',
      validationMessage: 'Please enter a valid email',
      required: true,
      defaultValue: '',
      autocomplete: 'email',
      placeholder: 'Email Address*',
      maxLength: 256,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
    {
      type: 'textarea',
      label: 'Your Message',
      name: 'message',
      validationMessage: 'Please enter a message',
      required: false,
      defaultValue: '',
      maxLength: 5000,
      placeholder: 'Type your question or comment here',
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
    {
      type: 'checkbox',
      label:
        "I have read and agree to the <a href='https://www.fijiwaterfoundation.org/privacy-policy.html'>Privacy Policy</a> and <a href='https://www.fijiwaterfoundation.org/terms-of-use.html'>Terms of Use</a>.*",
      name: 'accept_legal',
      validationMessage: 'This field is required.',
      required: true,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
  ],
};

const ContactFormJSON = {
  formId: 'fiji_foundation_contact_us',
  formVariables: contactFormVariables,
  data: [hiddenFields, formFields],
};

export default ContactFormJSON;
